import { render } from "./trainTransport.vue?vue&type=template&id=6368351a&scoped=true"
import script from "./trainTransport.vue?vue&type=script&lang=js"
export * from "./trainTransport.vue?vue&type=script&lang=js"

import "./trainTransport.vue?vue&type=style&index=0&id=6368351a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6368351a"]])

export default __exports__